---
title: "Introducing Ref-Based Checkpoint Storage"
description: "Give checkpoints their own Git refs for faster, lighter pushes and reads as your agent history grows."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. Today, we’re introducing ref-based checkpoint storage, an opt-in storage option designed to keep checkpoint pushes and reads fast as your agent history grows.

By default, Entire stores checkpoints on a shared Git branch called `entire/checkpoints/v1`. When you enable ref-based storage, each new checkpoint gets its own [Git ref](https://git-scm.com/book/en/v2/Git-Internals-Git-References), a named pointer inside your repository that Entire creates and manages for you.

<CloudflareStreamVideo
  videoId="b98e88a25e7aa76cd6590eafbf4a931d"
  title="Ref-based checkpoint storage"
  aspectRatioPercent="64.5933014354067%"
  autoplay
/>

Once enabled, Entire saves and retrieves each checkpoint independently, so operations stay fast even as your repository accumulates more agent history. Multiple agents can also save their work at the same time without competing to update a shared branch. Most of this change happens behind the scenes, so your workflow stays the same, allowing you to create, search, explain, and resume checkpoints with the same Entire commands.

## Try It

Ref-based checkpoint storage is available in [Entire CLI 0.8.42](https://github.com/entireio/cli/releases/tag/v0.8.42) and later.

To enable it in a new repository, run:

```shell
entire enable --checkpoint-backend refs
```

To enable it in an existing Entire-enabled repository, run:

```shell
entire configure --checkpoint-backend refs
```

Ref-based storage uses longer, time-sortable checkpoint IDs:

```text
Branch-based: a3b2c4d5e6f7
Ref-based:    01KVBJCWYA4YW6J5M9GP655HZN
```

Learn more in the [ref-based checkpoint storage documentation](https://docs.entire.io/guides/checkpoints/store-checkpoints-with-your-code#ref-based-storage).

Boop.
